import React from 'react';
import UserModulesHeader from '../UserModulesHeader';
import UserModulesContent from '../UserModulesContent';

const UserModulesServer = () => {
    return (
        <>
            <UserModulesHeader />
            <UserModulesContent />
        </>
    );
};

export default UserModulesServer;
